import { colors } from './colors';
import { fonts } from '../fonts';
import { buttons } from './buttons';

import { lighten, rgba } from 'polished';

const { font } = fonts;

export const pureOttTheme = {
	...colors,
	...fonts,
	...buttons,
	darkMode: true,
	grayMedium: colors.grayMediumDarkTheme,
	general: {
		body: colors.palette.background.body,
		linkHover: colors.white,
		error: colors.palette.error,
		padding: {
			mobile: 2,
			desktop: 6
		}
	},
	buttonDefault: {
		bg: 'linear-gradient(to bottom,#3182b5 0,#2f599c 100%)',
		text: colors.white,
		border: '#183e58'
	},
	heading: {
		first: {
			white: colors.white,
			primary: colors.white
		}
	},
	line: colors.blackGray,
	dashedLine: colors.grayMediumDarkTheme,
	activeGradientLine: {
		colorStart: colors.palette.primary.light,
		colorEnd: colors.palette.primary.main,
		tvsmart: {
			colorStart: '#FFEB00',
			colorMiddle: '#EAB036',
			colorEnd: '#CB931E'
		}
	},
	loaderBg: 'transparent',
	body: {
		bg: colors.palette.background.body
	},
	header: {
		bg: colors.palette.background.body,
		icon: colors.grayMediumDarkTheme,
		iconActive: colors.white,
		separateLine: colors.grayMediumDarkTheme
	},
	footer: {
		bg: colors.palette.background.body,
		fontSize: 1.2,
		copyrights: {
			fontSize: 1.1
		},
		links: {
			fontSize: 1.1
		}
	},
	navSearch: {
		bg: colors.palette.background.body,
		inputBg: 'transparent'
	},
	navSearchCloseIcon: colors.grayMediumDarkTheme,
	searchBox: {
		bg: '#101621',
		itemHoverBg: colors.blueAzureDark,
		itemInfo: '#95A1AF',
		itemInfoHover: colors.white,
		itemTitleHover: colors.white,
		shadow: 'rgba(0, 0, 0, 0.15)',
		shadowMobile: 'rgba(255, 255, 255, 0.35)',
		nameFontSize: 1.5,
		linkFontSize: 1.3
	},
	nav: {
		height: 6.5,
		menuActiveText: colors.white,
		menuActiveTextDistintive: colors.blackPearl,
		test: colors.palette.error
	},
	sidebar: {
		bg: '#101621',
		itemHoverBg: colors.blueAzureDark,
		removeIcon: colors.grayMediumDarkTheme,
		removeIconHover: colors.white,
		closeIcon: colors.grayMediumDarkTheme,
		arrowHover: colors.white
	},
	popover: {
		bg: '#101621',
		border: '#2d343d',
		icon: colors.grayMediumDarkTheme,
		iconActive: colors.palette.primary.main
	},
	button: {
		primaryVod: {
			color: colors.white,
			beforeBgColor1: '#3562a5',
			beforeBgColor2: '#4387d0'
		},
		parental: {
			bgColor1: '#3182b5',
			bgColor2: '#2f599c'
		}
	},
	dropdown: {
		button: {
			bg: 'transparent',
			color: colors.grayMediumDarkTheme,
			colorHover: colors.white
		},
		menu: {
			bg: '#101621',
			itemColor: colors.grayMediumDarkTheme,
			itemHoverColor: colors.white,
			itemActiveColor: colors.white,
			itemHoverBg: colors.blueAzureDark,
			itemHoverBgMobile: colors.transparent,
			itemColorDistinctive: colors.yellow,
			itemHoverColorDistinctive: colors.blackPearl,
			itemHoverBgDistinctive: colors.yellow,
			fontSize: 1.4
		}
	},
	hamburger: {
		bg: colors.white
	},
	modal: {
		bg: '#0D0F13',
		titleColor: colors.grayMediumDarkTheme,
		primary: {
			backgroundColor: 'rgba(0, 0, 0, 0.8)',
			backdropFilter: 'blur(1px)'
		},
		secondary: {
			backgroundColor: 'rgba(0, 0, 0, 0.75)',
			backdropFilter: 'blur(3px)'
		}
	},
	channels: {
		gridItemLinkHover: colors.white
	},
	epg: {
		grayLight: '#fbfafc',
		bg: '#151d29',
		bgHoverColorStart: colors.palette.primary.light,
		bgHoverColorEnd: colors.palette.primary.main,
		gridItemShadow: '#080C12',
		gridItemCategory: '#95A1AF',
		catchup: {
			bg: 'linear-gradient(to right, #2b323e 0, #2b323e)',
			bgHover: 'linear-gradient(to right, #f8a030 0, #e36845)'
		},
		calendarHover: colors.white,
		timeMarker: colors.grayReddish
	},
	programDetails: {
		heading: colors.white,
		paragraph: '#e6e3df',
		name: '#808181',
		table: {
			row: {
				bg: '#161e29',
				hoverBg: '#224BA1'
			}
		}
	},
	vodDetails: {
		gradient: colors.palette.background.body,
		background: colors.palette.background.body,
		closeHover: lighten(0.3, colors.palette.primary.main)
	},
	user: {
		line: colors.blackGray,
		topHeadingFilter: colors.grayMediumDarkTheme,
		tableTitle: colors.grayMediumDarkTheme,
		tableItem: '#6C7076',
		tableItemName: colors.blueAzureDark,
		tableItemNameHover: colors.white,
		showChannel: colors.grayMediumDarkTheme,
		removeIcon: colors.grayMediumDarkTheme,
		removeIconHover: colors.white,
		tags: {
			vodInProfile: colors.blueDark
		},
		productItem: {
			title: colors.white,
			info: '#aaadb2'
		},
		agreements: {
			color: colors.whiteTransparent07,
			checkboxBorderColor: '#4197ca',
			checkboxBorderColorError: colors.palette.error,
			checkboxIconColor: colors.graySoft,
			obligatoryPrefixColor: colors.whiteTransparent07
		},
		color: { primary: colors.white, secondary: rgba(colors.white, 0.8), highlight: colors.blueAzure },
		border: { primary: rgba(colors.white, 0.08) }
	},
	allMovies: {
		breadcrumbs: {
			color: 'rgba(255, 255, 255, 0.7)'
		},
		menuButton: {
			color: '#636363'
		}
	},
	authentication: {
		contentBg: colors.blackPearl,
		headingColor: colors.white,
		infoColor: colors.whiteTransparent07,
		linkColor: colors.blueAzure,
		linkHoverColor: colors.graySoft,
		lineColor: colors.blackGray,
		agreements: {
			color: colors.graySemiSoft,
			checkboxBorderColor: colors.graySoft,
			checkboxIconColor: colors.graySoft,
			obligatoryPrefixColor: colors.whiteTransparent07
		},
		input: {
			color: '#858585',
			borderColor: '#2C343D',
			focusBorderColor: colors.blueAzure
		},
		loginTabs: {
			color: '#dadada80',
			checkedColor: colors.graySoft,
			borderColor: '#242830'
		},
		authButtons: {
			fontSize: 1.6,
			color: colors.semiWhite
		}
	},
	slider: {
		arrow: {
			color: '#95A1AF',
			sliderControllerBgColor: 'transparent',
			sliderControllerBgHoverColor: 'rgba(33, 64, 154, 0.8)'
		},
		available: {
			bgColorStart: '#46abe6',
			bgColorEnd: '#3562a5'
		}
	},
	payment: {
		bgColor: 'rgba(0, 0, 0, 0.73)',
		gradientBox: {
			color1: 'rgba(47, 215, 255, 1)',
			color2: 'rgba(23, 129, 247, 1)'
		},
		gradientRadial: {
			color1: 'rgb(22, 56, 99)',
			color2: colors.black
		},
		paymentOptions: {
			gradientBox: {
				color1: '#cbd3da',
				color2: '#45748c',
				color3: '#32559a'
			},
			paragraph: {
				color: colors.white
			},
			box: {
				color1: 'rgb(17, 44, 74)',
				color2: '#3a5e82'
			},
			name: {
				color: colors.white,
				fontWeight: fonts.font.medium
			},
			info: {
				color: colors.grayLight,
				fontWeight: fonts.font.normal
			},
			price: {
				color: colors.white,
				fontWeight: fonts.font.normal,
				opacity: '0.7'
			},
			paymentField: {
				labelColor: '#cbd6e0',
				color: colors.white,
				placeholderColor: '#cbd6e0',
				borderColor: '#819bb2',
				errorBorderColor: colors.palette.error
			}
		},
		voucher: {
			wrapper: {
				borderColor: '#e5e2e124'
			},
			text: {
				color: colors.white
			},
			input: {
				color: colors.white,
				borderColor: 'rgba(105, 114, 135, 0.29)'
			}
		},
		emailNotConfirmed: {
			headingColor: colors.white,
			paragraph: {
				color: colors.white,
				fontWeight: fonts.font.light
			}
		}
	},
	landingPage: {
		registrationButton: {
			color: colors.white,
			bgContainerColor: '#31549b',
			borderColor: '#313131',
			bgDefault: {
				color1: '#31549b',
				color2: colors.blueAzureDark
			},
			bgHover: {
				color1: colors.blueAzureDark,
				color2: '#31549b'
			}
		},
		devices: {
			itemColor: colors.blueAzure
		}
	},
	sliderCard: {
		width: 245,
		height: 174,
		mobileWidth: 170,
		mobileHeight: 120,
		background: 'rgba(255, 255, 255, 0.04)'
	},
	card: {
		width: 509,
		height: 541,
		borderRadius: '8px',
		color: 'rgba(255, 255, 255, 0.04)'
	},
	faq: {
		backgroundColor: '#0b111b',
		primaryBackgroundColor: '#0a101a',
		header: {
			fontSizeBase: 1.6,
			fontSizeMin: 2.2,
			fontSize: 3,
			fontWeight: font.medium
		},
		body: {
			fontSizeBase: 1.4,
			fontSize: 2,
			fontWeight: font.distinct
		},
		borderColor: 'rgba(255,255,255,0.2)',
		arrowColor: colors.paleBlue
	},
	invoice: {
		color: colors.graySemiSoft,
		grid: {
			maxSpan: 16
		},
		input: {
			borderColor: colors.graySoft,
			color: colors.grayMediumDarkTheme,
			backgroundColor: colors.invoice.input,
			placeholder: colors.silver
		}
	},
	personalData: {
		form: {
			input: {
				borderColor: colors.graySoft,
				backgroundColor: colors.blackPearl02,
				placeholderColor: colors.silver
			},
			checkbox: {
				border: colors.graySoft,
				borderChecked: colors.blueAzure,
				backgroundColor: colors.blueAzure
			},
			select: {
				border: colors.graySoft,
				borderOpen: colors.blueAzure,
				backgroundColor: colors.blackPearl02,
				placeholderColor: colors.silver,
				boxShadowColor: colors.blueAzure075
			}
		}
	},
	operators: {
		card: {
			borderColor: colors.operators.card.borderColor,
			borderColorHover: colors.gray
		}
	},
	drag_and_drop: {
		translucent: 'rgba(0, 0, 0, 0.075)',
		redShadow: rgba(colors.palette.error, 0.5),
		blueShadow: 'rgba(102, 175, 233, 0.6)',
		zone: {
			background: 'rgba(255, 255, 255, 0.03)'
		}
	},
	mobile: {
		title: '#efad18'
	},
	decoder: {
		header: {
			descColor: colors.yellow,
			descShadow: colors.palette.primary.dark
		}
	},
	introduce: {
		color: colors.white,
		colorDistinct: colors.yellow,
		bg: colors.blackPearl,
		bgSecondary: colors.grayPearl,
		baseSection: {
			buttonShadow: colors.blueAzure,
			font: {
				base: {
					title: 2,
					titleLH: 3,
					desc: 1.4,
					descLH: 2,
					button: 1.2,
					carousel: 1.5
				},
				min: {
					title: 3,
					titleLH: 4,
					descLH: 2.4,
					carousel: 2
				},
				medium: {
					title: 3.5,
					titleLH: 4.5,
					desc: 1.5,
					descLH: 3,
					button: 1.6
				},
				large: {
					title: 4,
					titleLH: 6.6,
					desc: 1.8
				},
				max: {
					title: 4.4,
					desc: 2
				}
			}
		},
		largeTitleSection: {
			font: {
				base: 2,
				baseLH: 3,
				xmin: 3,
				xminLH: 4.5,
				min: 4.4,
				minLH: 6.6
			}
		},
		functionalities: {
			font: {
				base: 2,
				baseLH: 2.4,
				min: 3,
				minLH: 3.6
			}
		},
		features: {
			font: {
				title: {
					base: 1.5,
					medium: 2,
					large: 2.4
				},
				desc: {
					base: 1.3,
					medium: 1.8,
					max: 2
				}
			}
		},
		faq: {
			font: {
				title: {
					base: 2.4,
					min: 3
				}
			}
		},
		contact: {
			font: {
				title: {
					base: 2.4,
					min: 4.4
				},
				phone: {
					base: 2.4,
					min: 4.4
				},
				schedule: {
					base: 1.8,
					min: 2.4
				}
			},
			phoneColor: colors.blueAzure
		}
	},
	configurator: {
		color: {
			primary: colors.white,
			secondary: rgba(colors.white, 0.8),
			contrast: colors.yellow,
			highlight: colors.blueAzure,
			accent: colors.silver,
			error: colors.palette.error,
			dark: colors.black
		},
		bg: {
			primary: colors.blackPearl,
			secondary: rgba(colors.white, 0.04),
			contrast: colors.white,
			dark: colors.black,
			modal: colors.darkCharcoal,
			skeleton: colors.charcoalBlue
		},
		steps: {
			color: {
				default: colors.white,
				active: colors.darkNavy
			}
		}
	},
	form: {
		color: {
			primary: colors.white,
			highlight: colors.blueAzure,
			error: colors.palette.error
		},
		bg: {
			primary: '#040404',
			secondary: colors.black 
		},
		light: {
			color: {
				primary: '#12100b',
				secondary: colors.palette.divider,
				error: '#AB1F1F',
				errorSecondary: '#D11D1D',
				success: '#008F12',
				hint: '#0A101A'
			},
			bg: {
				primary: colors.palette.white,
				secondary: '#283f94',
				contrast: colors.palette.black,
				error: '#F6EFEF',
				success: '#F3FFF5'
			}
		}
	},
	tooltip: {
		color: { primary: rgba(colors.white, 0.7) },
		bg: { primary: colors.darkNavy },
		border: { primary: rgba(colors.white, 0.18) }
	},
	section: {
		bullet: {
			primary: rgba(colors.white, 0.2),
			secondary: colors.white,
			highlight: colors.blueAzure
		},
		bg: {
			primary: colors.blackPearl,
			secondary: colors.black,
			contrast: colors.white,
			highlight: colors.blueAzure
		},
		color: {
			primary: colors.white,
			secondary: colors.graySoft,
			highlight: colors.blueAzure
		}
	}
};
